var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuttrema-layout-three-vertical',[_c('participant-standard-header',{attrs:{"slot":"top","meta":_vm.meta,"showOnMobileAndTablet":_vm.showOnMobileAndTablet},slot:"top"}),_vm._v(" "),_c('template',{slot:"middle"},[_c('form-forgot-password',{staticClass:"is-center-vertical",attrs:{"AuthenticationForgotPassword":_vm.AuthenticationForgotPassword},on:{"submit":_vm.onFormSubmit}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1bc3790","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/participant/public/forgot-password/page-participant-forgot-password.vue
// module id = 3268
// module chunks = 0